// extracted by mini-css-extract-plugin
export default {"ldsSpinner":"PageSpinner_ldsSpinner__VCeQb","loading":"PageSpinner_loading__jqu7E"};